import { ExperienceEntry } from 'utils/cv-form-db/types';
import { isExperienceComplete } from './utils';

export const useExperienceForm = (values: ExperienceEntry) => {
  return {
    isComplete: isExperienceComplete(values)
  };
};
